import { UnitRateKey, UnitRateModels, unitRateKeyToModelFeatureKey } from '@aloft/toolkit-shared';

export const isRegressionModelReliableForFeature = (
  unitRateModels: UnitRateModels | null | undefined,
  unitRateKey: UnitRateKey,
): boolean => {
  const modelFeatureKey = unitRateKeyToModelFeatureKey[unitRateKey];
  if (!modelFeatureKey) return false;

  const regression = unitRateModels?.regression;
  if (!regression || regression.status !== 'success') return false;

  return (
    regression.output.modelDiagnostics.reliable &&
    regression.output.unitRates[modelFeatureKey].reliable
  );
};

export const isSensitivityModelReliableForFeature = (
  unitRateModels: UnitRateModels | null | undefined,
  unitRateKey: UnitRateKey,
): boolean => {
  const modelFeatureKey = unitRateKeyToModelFeatureKey[unitRateKey];
  if (!modelFeatureKey) return false;

  const sensitivityAnalysis = unitRateModels?.sensitivityAnalysis;
  if (!sensitivityAnalysis) return false;

  return sensitivityAnalysis[modelFeatureKey]?.selectedRate.reliable ?? false;
};
